/** `member` = a person. `system` = the seeded "Lean In" official sender
 *  account: never listed, never a recipient; clients badge it as Official. */
export const ACCOUNT_KINDS = ['member', 'system'];
// The graduation years a profile can carry (the profile update request and
// the account form).
export const EDUCATION_GRAD_YEAR_MIN = 1900;
export const EDUCATION_GRAD_YEAR_MAX = 2100;
// Most member ids one batch profile read (POST /members/profiles) accepts. The
// web client splits a larger set into reads of this size.
export const MEMBER_PROFILES_BATCH_MAX_IDS = 100;
//# sourceMappingURL=profile.js.map